module.exports = __webpack_public_path__ + "img/7.415a1748.webp";